import(/* webpackMode: "eager" */ "C:\\wamp64\\www\\bloomfeeds\\src\\app\\contact\\page.tsx");
